import { AppBar, Toolbar, IconButton } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";

const NAV_WIDTH = 280;
const HEADER_MOBILE = 64;
const HEADER_DESKTOP = 92;

export const StyledRoot = styled(AppBar)(({ theme }) => ({
    backdropFilter: `blur(6px)`,
    WebkitBackdropFilter: `blur(6px)`,
    backgroundColor: alpha(theme.palette.background.default, 0.8),
    boxShadow: 'none',
    [theme.breakpoints.up('lg')]: {
        width: `calc(100% - ${NAV_WIDTH + 1}px)`,
    },
}));

export const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    minHeight: HEADER_MOBILE,
    [theme.breakpoints.up('lg')]: {
        minHeight: HEADER_DESKTOP,
        padding: theme.spacing(0, 5),
    },
}));

export const StyledLogo = styled('img')(({ theme }) => ({
    marginLeft: "10px",
    marginRight: "10px",
    height: "50px",
    width: "50px",
    [theme.breakpoints.up('lg')]: {
        display: 'none'
    },
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
    bgcolor: alpha(theme.palette.grey[900], 0.8),
    [theme.breakpoints.up('lg')]: {
        display: 'none'
    },
}));
